import { api } from "@/api";

/** * ====================================================================
 * today's priorities and partner highlights are used in the widgets on the home page
 * ====================================================================
 */
// export async function getTodaysPriorities(): Promise<any> {
//   const res = await api.todaysPriorities();
//   return res;
// }

export async function getPartnerHighlights(): Promise<any> {
  const res = await api.partnerHighlights();
  return res;
}

/** * ====================================================================
 * impact targets are used in the impact targets widget on the home page
 * ====================================================================
 */
export async function getImpactTargets(): Promise<any> {
  const res = await api.impactTargets();
  return res;
}

/** * ====================================================================
 * resources are used in the resources widget on the home page
 * ====================================================================
 */
export async function getResources(): Promise<any> {
  const res = await api.resources();
  return res;
}

/** * ====================================================================
 * payments pipeline data is used in the payments pipeline widget on the home page
 * ====================================================================
 */
export async function getPaymentsPipeline(): Promise<any> {
  const res = await api.paymentsPipeline();
  return res;
}
``;

/** * ====================================================================
 * quick links are used in the quick links widget on the home page
 * ====================================================================
 */
export async function getQuickLinkApps(upn: string, role: string): Promise<any> {
  const res = await api.quickLinks(upn, role);
  return res;
}

export async function addQuickLinkApp(payload: {
  upn: string;
  roleCode: string;
  name: string;
  url: string;
  displayOrder: number;
}) {
  return api.addQuickLink(payload);
}

export async function reorderQuickLinks(
  items: { id: string; displayOrder: number }[],
  upn: string,
  role: string
) {
  return api.reorderQuickLinks(items, upn, role);
}

export async function deleteQuickLinkApp(id: string) {
  return api.deleteQuickLink(id);
}

export async function getQuickLinksConfig(): Promise<any> {
  const res = await api.quickLinksConfig();
  return res;
}

export async function updateQuickLinksConfig(payload: {
  roleCode: string;
  appName: string;
  appUrl: string;
  isActive: boolean;
}): Promise<any> {
  const res = await api.quickLinksConfigUpdate(payload);
  return res;
}

/* ====================================================================
 * dashboard config is used to manage the visibility of widgets on the home page
 * ====================================================================
 */
export async function getDashboardConfig(): Promise<any> {
  const res = await api.dashboardConfig();
  return res;
}

export async function updateDashboardConfig(payload: {
  roleCode: string;
  widgets: { feature_code: string; display_order: number }[];
  updatedBy: string;
}): Promise<any> {
  const res = await api.dashboardConfigUpdate(payload);
  return res;
}